export default __webpack_public_path__ + "static/j_wolff-e04cb259150bb95a68df259b710b196f.jpg";